import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const adminByRequest = defineConnector({
  identifier: "adminByRequest",
  name: "Admin By Request",
  tagLine: "Privileged access management",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: ({ apiAddress }) =>
    apiAddress
      ? `${apiAddress.replace(/\./g, "\\.").replace(/\/$/, "")}/.*`
      : "https://dc1\\.adminbyrequest\\.com/.*",
  auth: (app) => headerAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the [Admin By Request documentation](https://docs.adminbyrequest.com/integrations/public-api.htm) under the **API** section to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API details",
      items: [
        {
          kind: "url",
          label: "API address",
          placeholder: "https://dc1.adminbyrequest.com",
          required: true,
          target: { kind: "configuration", field: "apiAddress" },
          helperText:
            "Your Admin By Request data center URL (e.g., https://dc1.adminbyrequest.com).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiAddress }) => `${apiAddress}/api/inventory`,
  },
});
